import React from "react";
import logo from "/assets/images/main_logo.svg";
import { NavLink } from "react-router-dom";
import { decode } from "../config";

const WEBSITE_NAME = decode(window._env_?.WEBSITE_NAME);
const WEBSITE_LINK = decode(window._env_?.WEB_SITE_LINK);
const INSTAGRAM_LINK = decode(window._env_?.INSTAGRAM_LINK);
const FACEBOOK_LINK = decode(window._env_?.FACEBOOK_LINK);
const TIKTOK_LINK = decode(window._env_?.TIKTOK_LINK);

function Footer() {
  return (
    <footer aria-label="Footer" className="bg-white dark:bg-gray-900 mt-8">
      <hr className="my-6 border-gray-200 sm:mx-auto dark:border-gray-700 lg:my-8" />

      <div className="mx-auto w-full max-w-screen-2xl p-4 py-6 lg:py-8">
        <div className="md:flex md:justify-between">
          {/* Logo */}
          <div className="mb-6 md:mb-0 flex justify-start md:justify-start">
            <a href={WEBSITE_LINK} className="inline-flex">
              <img
                src={logo}
                alt={`${WEBSITE_NAME} Logo`}
                width={512}
                height={128}
                fetchPriority="high"
                decoding="async"
                className=" w-auto h-16 sm:h-20 md:h-24 lg:h-28 xl:h-32 object-contain "
              />
            </a>
          </div>

          {/* Links Grid */}
          <div className="grid grid-cols-1 gap-y-8 gap-x-16 sm:grid-cols-3">
            {/* Social */}
            <div>
              <h2 className="mb-6 text-sm font-semibold text-gray-900 uppercase dark:text-white">
                Follow us
              </h2>
              <ul className="flex flex-col space-y-4 text-gray-600 dark:text-gray-400 font-medium">
                <li>
                  <a
                    href={INSTAGRAM_LINK}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-2 hover:underline"
                  >
                    <svg
                      className="w-5 h-5"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z"
                      />
                    </svg>
                    <span>Instagram</span>
                  </a>
                </li>
                <li>
                  <a
                    href={FACEBOOK_LINK}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-2 hover:underline"
                  >
                    <svg
                      className="w-5 h-5"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path d="M22 12a10 10 0 10-11.5 9.95v-7.05h-2.3V12h2.3V9.7c0-2.27 1.35-3.55 3.43-3.55.99 0 2.02.18 2.02.18v2.23h-1.14c-1.12 0-1.47.7-1.47 1.42V12h2.5l-.4 2.9h-2.1v7.05A10 10 0 0022 12z" />
                    </svg>
                    <span>Facebook</span>
                  </a>
                </li>
                <li>
                  <a
                    href={TIKTOK_LINK}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-2 hover:underline"
                  >
                    <svg
                      className="w-5 h-5"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path d="M16 8.04a4.53 4.53 0 01-1.03-.12V15a4.5 4.5 0 11-3-4.24v2.12a2.25 2.25 0 102.25 2.25V4h1.5a3 3 0 003 3v1.5a4.48 4.48 0 01-2.72-.46z" />
                    </svg>
                    <span>TikTok</span>
                  </a>
                </li>
              </ul>
            </div>

            {/* Legal */}
            <nav>
              <h2 className="mb-6 text-sm font-semibold text-gray-900 uppercase dark:text-white">
                Legal
              </h2>
              <ul className="flex flex-col space-y-4 text-gray-600 dark:text-gray-400 font-medium">
                <li>
                  <NavLink to="/privacy-policy" className="hover:underline">
                    Privacy Policy
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/return-policy" className="hover:underline">
                    Return Policy
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/term-and-conditions"
                    className="hover:underline"
                  >
                    Terms & Conditions
                  </NavLink>
                </li>
              </ul>
            </nav>

            {/* Help */}
            <nav>
              <h2 className="mb-6 text-sm font-semibold text-gray-900 uppercase dark:text-white">
                Help
              </h2>
              <ul className="flex flex-col space-y-4 text-gray-600 dark:text-gray-400 font-medium">
                <li>
                  <NavLink to="/howtoorder" className="hover:underline">
                    How to Order
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/paymenthelp" className="hover:underline">
                    How to Pay
                  </NavLink>
                </li>
              </ul>
            </nav>
          </div>
        </div>
        <hr className="my-6 border-gray-200 sm:mx-auto dark:border-gray-700 lg:my-8" />
        <div className="sm:flex sm:items-center sm:justify-between">
          <span className="text-sm text-gray-600 sm:text-center dark:text-gray-400">
            © 2026{" "}
            <a href={WEBSITE_LINK} className="hover:underline">
              {WEBSITE_NAME}
            </a>
            . All Rights Reserved.
          </span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
